import React, { FunctionComponent, useContext } from 'react';
import useMediaQuery from '../../utils/hooks/use-media';
import { dotsToComma, mainMediaMobile } from '../../services/helpers';
import { Close } from '../../icons/components';
import { FormContext } from '../../store/context/formContext';
import { numberToCurrency } from '../../utils/prices';

interface OverviewModalProps {
    toggleOverview: any;
    componentRef: any;
}
const OverviewModal: FunctionComponent<OverviewModalProps> = ({ toggleOverview, componentRef }) => {
    const mediaMatches = useMediaQuery(mainMediaMobile);
    const { form, calculatedMortgageType, data, selectedPeriod } = useContext(FormContext);

    return (
        <div className="modal-wrapper">
            <div
                className={`overview-modal-wrapper ${
                    mediaMatches && 'overview-modal-wrapper--mobile'
                }`}>
                <div className="close-overview" onClick={toggleOverview}>
                    <Close width={25} height={25} />
                </div>

                <div className="overview-modal" ref={componentRef}>
                    <div ref={componentRef}>
                        <div className="overview-modal-title">Jouw berekening</div>

                        <div className="overview-modal-subtitle overview-modal-subtitle-with-background overview-modal-field">
                            <div>Maximale hypotheekbedrag</div>
                            <div>
                                {numberToCurrency(
                                    data?.maximumMortgageForMonthlyPayment || 0,
                                    true,
                                )}
                            </div>
                        </div>
                        <div className="overview-modal-deze">
                            <h3>Deze berekening is gebaseerd op:</h3>
                        </div>
                        <div className="overview-modal-deze-wrapper">
                            <div className="overview-modal-field ">
                                <div>Gewenste bruto maandlasten</div>
                                <div>{numberToCurrency(form?.monthlyCost || 0, true)}</div>
                            </div>
                            <div className="overview-modal-field">
                                <div>Hypotheekvorm</div>

                                <div>{calculatedMortgageType === 4 ? 'Annuïteiten' : 'Linear'}</div>
                            </div>

                            <div className="overview-modal-field">
                                <div>Looptijd</div>

                                <div>30 jaar</div>
                            </div>

                            <div className="overview-modal-field">
                                <div>Rente</div>

                                <div>{dotsToComma(form?.interest)} %</div>
                            </div>

                            <div className="overview-modal-field">
                                <div>Rentevaste periode</div>

                                <div>{selectedPeriod} jaar rentevast</div>
                            </div>
                            <div className="overview-modal-field">
                                <div>Nationale Hypotheek Garantie (NHG)</div>

                                <div>{form.isNhg === 'true' ? 'Ja' : 'Nee'}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OverviewModal;
